import { render, staticRenderFns } from "./HealthReportSurveillanceReasonCreateOrUpdate.vue?vue&type=template&id=dec11dba&"
import script from "./HealthReportSurveillanceReasonCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./HealthReportSurveillanceReasonCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports